import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import { Container } from 'react-grid-system';
import classNames from 'classnames/bind';
import { getLinkTag, trackEvent, windowExists } from '../../utils';
import Button from '../Button';
import Dropdown from '../Dropdown';


import styles from './navigation.module.scss';

const cx = classNames.bind(styles);

class Navigation extends React.Component {
  render() {
    return (
      <StaticQuery
        query={navigationQuery}
        render={(data) => {
          const {
            logoImage, menuItems, cta, globalPageUrl, userAreaUrl,
          } = data.contentfulNavigation;

          if (!windowExists) {
            return;
          }

          const location = `${window.location.pathname}${window.location.hash}`;

          return (
            <header className={styles.header}>
              <div className={styles.bar}>
                <Container fluid xs sm md>
                  <div className={styles.wrapper}>
                    <nav className={styles.nav}>
                      {globalPageUrl && (
                        <ul className={styles.list}>
                          <li className={styles.listItem}>
                            <a href={globalPageUrl} className={styles.link}>
                              <i className={`${styles.icons} fas fa-long-arrow-alt-left`}/>
                              Money20/20 Global
                            </a>
                          </li>
                        </ul>
                      )}

                      {userAreaUrl && (
                        <ul className={styles.list}>
                          <li className={styles.listItem}>
                            <a
                              href={userAreaUrl}
                              onClick={trackEvent.bind(null, 'Navigation', 'Account', null)}
                              className={styles.link}
                            >
                              <i className={`${styles.icons} far fa-user`}/>
                              My account
                            </a>
                          </li>
                        </ul>
                      )}
                    </nav>
                  </div>
                </Container>
                </div>
              <div className={styles.main}>
                <Container fluid xs sm md>
                  <div className={styles.wrapper}>
                    <nav className={styles.nav}>
                      <div className={styles.logo}>
                        <Link to="/" onClick={trackEvent.bind(null, 'Navigation', 'Home', null)}>
                          <img src={logoImage.file.url} alt="Money2020 Asia" />
                        </Link>
                      </div>

                      <div className={styles.menuWrap}>
                        <ul className={styles.list}>
                          {menuItems.map((item) => {
                            if (!item.pathname) {
                              return (
                                <li key={item.id} className={styles.listItem}>
                                  <Dropdown trackEvents openDirection="left" options={item.subMenu}>{item.label}</Dropdown>
                                </li>
                              );
                            }
                            const linkInformation = getLinkTag(item.pathname);
                            const Tag = linkInformation.tag;
                            const { tagProps } = linkInformation;

                            const tagClassName = cx({
                              link: true,
                              active: location.indexOf(item.pathname) >= 0,
                            });

                            if (linkInformation.isExternalLink) {
                              tagProps.gtmEventName = 'Navigation';
                              tagProps.label = item.label;
                            } else {
                              tagProps.onClick = function () {
                                trackEvent('Navigation', item.label);
                              };
                            }

                            return (
                              <li key={item.id} className={styles.listItem}>
                                <Tag
                                  {...tagProps}
                                  className={tagClassName}
                                >
                                  {item.label}
                                </Tag>
                              </li>
                            );
                          })}
                        </ul>

                        {cta && (
                          <div className={styles.cta}>
                            <Button
                              link={cta.url}
                              size="small"
                              modifierclass={styles.desktopBtn}
                              istargetblank={cta.istargetblank}
                              gtmEventName={cta.gtmEventName}
                              gtmEventType={cta.gtmEventType}
                              variant="secondary"
                            >
                              {cta.label}
                            </Button>
                          </div>
                        )}
                      </div>
                    </nav>
                  </div>
                </Container>
              </div>
            </header>
          );
        }}
      />
    );
  }
}

export default Navigation;

const navigationQuery = graphql`
    query NavigationQuery {
        contentfulNavigation(contentfulid:{eq:"Main Menu"}) {
            id,
            logoImage {
                file {
                    url
                }
            },
            menuItems{
                id,
                label,
                pathname,
                subMenu{
                    id,
                    label,
                    pathname
                }
            },
            cta {
              ...Cta
            },
            userAreaUrl,
            globalPageUrl
        }
    }
`;
